import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit } from "@angular/core";
import { DataWidget } from "../../../models/data-widget.model";
import { DataService } from "src/app/services/data.service";
import { UserPermissionService } from "src/app/services/permission.service";
import { EMPTY, filter, forkJoin, from, of, Subject, switchMap, take, takeUntil, tap } from "rxjs";
import { environment } from "src/environments/environment";
import { ButtonTypeENUM } from "src/app/helpers/button-type.enum";
import { MenuService } from "src/app/services/menu-service.service";
import { AuthService } from "src/app/services/auth.service";

/**
 * WebContentComponent
 * Per nascondere in base ai permessi il pulsante nuovo
 * aggiungere in configurazione la props entityType.
 */
@Component({
  selector: "web-content",
  templateUrl: "./web-content.component.html",
  styleUrls: ["./web-content.component.scss"],
})
export class WebcontentComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() data!: DataWidget;
  @Input() template!: string;
  @Input() html!: string;
  @Input() props!: any;
  static compName = "WebContent";

  private destroy$: Subject<void> = new Subject();

  constructor(
    private ds: DataService,
    private _userPermissionService: UserPermissionService,
    private menuService: MenuService,
    private elementRef: ElementRef,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    if (this.props.replaceId) {
      this.ds.modelData$.subscribe((data) => {
        if (data && data[this.props.replaceId]) {
          this.html = this.html.replace(/\bid\b/g, data[this.props.replaceId]);
        }
      });
    }

    if (this.html) {
      this.html = this.html.replace(/<a([^>]*?)href="([^"]*?create[^"]*?)"([^>]*)>/gi, (match, beforeHref, href, afterHref) => {
        // Se esiste già una class, aggiungi 'd-none', altrimenti crea una nuova class
        if (/class="/i.test(beforeHref + afterHref)) {
          return match.replace(/class="([^"]*?)"/i, 'class="$1 d-none"');
        } else {
          return `<a${beforeHref}href="${href}"${afterHref} class="d-none">`;
        }
      });

    }
  }

handleClick(event: Event) {
    const target = event.target as HTMLElement;

    // Cerca il link o un suo genitore con la classe back-button
    const backBtn = target.closest('.back-button');
    if (backBtn) {
        event.preventDefault();
        window.history.back();
    }
}

  /**
   * @inheritdoc
   */
  ngAfterViewInit(): void {
    this.checkPermission();
  }

  checkPermission(): void {
    const buttons: HTMLAnchorElement[] = Array.from(this.elementRef.nativeElement.querySelectorAll("a")).filter(
      (a): a is HTMLAnchorElement => (a as HTMLAnchorElement).href.toLowerCase().includes("create")
    );

    if (!buttons.length) return;

    if (environment.allowPermissions) {
      buttons.forEach((button: HTMLAnchorElement) => button.classList.remove("d-none"));
      return;
    }


    from(this.authService.getRole()).pipe(
      take(1),
      switchMap((role) => {

        if (role === 'admin') {
          buttons.forEach((button: HTMLAnchorElement) => button.classList.remove("d-none"));
          return EMPTY;
        }


        return this.menuService.menuItem$.pipe(
          filter((item) => !!item),
          take(1),
          switchMap((item) =>
            forkJoin(
              buttons.map(() =>
                this._userPermissionService.loadCheckPermission(item?.entityType, ButtonTypeENUM.INSERT)
              )
            )
          ),
          tap((permissions) => {
            buttons.forEach((button, index) => {
              if (permissions[index]) {
                button.classList.remove("d-none");
              }
            });
          })
        );
      }),
      takeUntil(this.destroy$)
    ).subscribe();
  }


  /**
   * @inheritdoc
   */
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
